// extracted by mini-css-extract-plugin
export default {"refferral":"referralProgram_refferral__W6Fm8","header":"referralProgram_header__xEnGJ","body":"referralProgram_body__wAEGQ"};